import React, { FC } from 'react';
import classNames from 'classnames/bind';
import SmallButton from '@johnlewispartnership/wtr-ingredients/ingredients/SmallButton';

import { ChevronDownBold } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import styles from './ExpandCollapsePanel.scss';
import { ExpandCollapsePanelProps } from './types';

const ExpandCollapsePanel: FC<ExpandCollapsePanelProps> = ({
  title,
  children,
  collapsed = true,
  collapsedChildren,
  expandText,
  expandTextAsButton = false,
  collapseText,
  allowExpandCollapse = true,
  className,
  testAttribute,
  onClick,
}) => {
  const wrapperClass = () => {
    const cx = classNames.bind(styles);
    return cx('wrapper', className, collapsed ? 'closed' : 'open');
  };

  const expandCollapseLink = () => {
    let text;
    if (allowExpandCollapse) {
      if (expandText && collapsed) {
        text = expandText;
      }

      if (collapseText && !collapsed) {
        text = collapseText;
      }
    }

    const buttonElement = expandTextAsButton ? (
      <div className={styles.openCloseWrapper}>
        <SmallButton
          aria-expanded={!collapsed}
          label={text}
          onClick={onClick}
          theme="secondary"
          data-testid="show-more-button"
        />
      </div>
    ) : (
      <button
        aria-expanded={!collapsed}
        type="button"
        onClick={onClick}
        className={styles.openCloseButton}
        data-testid="show-more-link"
      >
        {text}
        <ChevronDownBold />
      </button>
    );

    return text && buttonElement;
  };

  return (
    <div className={wrapperClass()} data-testid={testAttribute}>
      <div className={styles.expandCollapseHeader}>
        {title && <h2 className={styles.heading}>{title}</h2>}
        {collapsedChildren && <div className={styles.collapsedChildren}>{collapsedChildren}</div>}
        {expandCollapseLink()}
      </div>
      <div className={styles.panel}>{children}</div>
    </div>
  );
};

export default ExpandCollapsePanel;
